module.exports = __webpack_public_path__ + "img/in-use-daniela-escobar@1x.d53a89e4.jpg";